import frontPage from "./components/front-page";
import accordion from "./components/accordion";
import {
  vlAddLightBox,
  vlHandleResize,
  vlSetCloser,
  vlPrepareVideos,
} from "./components/video-lightbox";
import lineManagers from "./components/line-managers";
import questionSteps from "./components/question-steps";
import glossaryLightbox from "./components/glossary-lightbox";
import confirmLink from "./components/confirmLink";
import footerLinks from "./components/footerLinks";
import quickLinks from "./components/quick-links";
import hotfixes from "./components/hotfixes";
import hotlineNumberSearch from "./components/hotline-number-search";
import searchHighlight from "./components/searchHighlight";

document.addEventListener("DOMContentLoaded", function () {
  // fontAwesome();
  // mobileNav();
  accordion();
  frontPage();
  vlAddLightBox();
  vlHandleResize();
  vlSetCloser();
  vlPrepareVideos();
  // loadPolicies();
  // prepareTiles();
  lineManagers();
  questionSteps();
  glossaryLightbox();
  confirmLink();
  footerLinks();
  quickLinks();
  hotfixes();
  hotlineNumberSearch();
  searchHighlight();
});
